import { Icon, Text } from "@certn/cascadia-react";
import { CascadiaColor, CascadiaMiniIcon } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";

export type CheckStatusProps = {
  type: CheckStatusType;
  children: React.ReactNode;
  testId?: string;
  hasGrayBackground?: boolean;
};

export type CheckStatusType =
  | "ready"
  | "progress"
  | "upgrade"
  | "expired"
  | "review"
  | "processing"
  | "complete"
  | "archived"
  | "dispute"
  | "cancelled"
  | "information-request";

export function CheckStatus(props: CheckStatusProps) {
  const { type, hasGrayBackground, children, testId } = props;

  return (
    <div
      className={css(wrapperStyles, {
        background: hasGrayBackground
          ? "var(--background-accent-neutral-weak)"
          : "var(--background-base)",
      })}
      data-testid={`${testId}-container`}
    >
      <Icon
        fill
        testID={testId}
        name={statusStyles[type].icon as CascadiaMiniIcon}
        color={statusStyles[type].iconColor as CascadiaColor}
      />
      <Text style="global/label-small">{children}</Text>
    </div>
  );
}

const wrapperStyles = {
  display: "flex",
  alignItems: "center",
  width: "fit-content",
  borderRadius: "var(--space-8)",
  gap: "var(--space-2)",
  paddingTop: "var(--space-1)",
  paddingRight: "var(--space-4)",
  paddingBottom: "var(--space-1)",
  paddingLeft: "var(--space-3)",
};

const statusStyles = {
  ready: {
    iconColor: "icon-success",
    icon: "emoji_flags",
  },
  upgrade: {
    iconColor: "icon-success",
    icon: "emoji_flags",
  },
  progress: {
    iconColor: "icon-info",
    icon: "resume",
  },
  expired: {
    iconColor: "icon-danger",
    icon: "notification_important",
  },
  review: {
    iconColor: "icon-info",
    icon: "quick_reference_all",
  },
  processing: {
    iconColor: "icon-info",
    icon: "document_scanner",
  },
  complete: {
    iconColor: "icon-success",
    icon: "check_circle",
  },
  archived: {
    iconColor: "text-disabled",
    icon: "inventory_2",
  },
  dispute: {
    iconColor: "icon-warning",
    icon: "hourglass_top",
  },
  cancelled: {
    iconColor: "icon-danger",
    icon: "block",
  },
  "information-request": {
    iconColor: "icon-warning",
    icon: "info",
  },
};
